import { render, staticRenderFns } from "./RepresentantesYApoderados.vue?vue&type=template&id=1dacb4f1&scoped=true"
import script from "./RepresentantesYApoderados.vue?vue&type=script&lang=js"
export * from "./RepresentantesYApoderados.vue?vue&type=script&lang=js"
import style0 from "./RepresentantesYApoderados.vue?vue&type=style&index=0&id=1dacb4f1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dacb4f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dacb4f1')) {
      api.createRecord('1dacb4f1', component.options)
    } else {
      api.reload('1dacb4f1', component.options)
    }
    module.hot.accept("./RepresentantesYApoderados.vue?vue&type=template&id=1dacb4f1&scoped=true", function () {
      api.rerender('1dacb4f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/RepresentantesYApoderados.vue"
export default component.exports